.root {
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 16px;
  justify-content: center;
  min-height: 60vh;
  padding: 32px;
  text-align: center;
}

.title {
  color: var(--color-foreground);
  font-size: 20px;
  font-weight: 600;
}

.message {
  color: var(--color-muted-foreground);
  font-size: 14px;
}

.button {
  background: var(--color-primary);
  border: none;
  border-radius: 8px;
  color: var(--color-primary-foreground);
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  padding: 10px 20px;
}
